import React from 'react';

import '../../sass/components/charts/OverallRatingView.scss';

const W = 230;
const H = W / 2;
const LINE_W = 16;

const EMPTY_COLOR = '#C4C4C4';
const FILL_COLOR_POOR = '#FFCC31';
const FILL_COLOR_GOOD = '#B5D45C';
const FILL_COLOR_SUPERB = '#037F5F';

export default class OverallRatingView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  renderTotalRating = () => {
    const { total = 0, percent = 0 } = this.props;
    const fillColor = percent > 66.666 ? FILL_COLOR_SUPERB : percent > 33.333 ? FILL_COLOR_GOOD : FILL_COLOR_POOR;
    const arcPath = `M${LINE_W/2},${H} A${H-LINE_W},${H-LINE_W},0,1,1,${W-LINE_W/2},${H}`;
    return (
      <div className='totalRating'>
        <div className='totalCount'>
          Out of {total} private ratings
        </div>
        <div className='totalChart'>
          <svg
            width={W}
            height={H}
            viewBox={`0 0 ${W} ${H}`}
            preserveAspectRatio='none'
          >
            <path
              fill='none'
              stroke={EMPTY_COLOR}
              strokeWidth={LINE_W}
              data-z-index='1'
              d={arcPath}
            />
          </svg>
          <svg
            width={W}
            height={H}
            viewBox={`0 0 ${W} ${H}`}
            preserveAspectRatio='none'
            style={{transform: `translate(0%, 50%) rotate(${percent*1.8-180}deg) translate(0%, -50%)`}}
          >
            <path
              fill='none'
              stroke={fillColor}
              strokeWidth={LINE_W}
              data-z-index='1'
              d={arcPath}
            />
          </svg>
          <div className='valueLabel'>{percent}%</div>
        </div>
        <label>Voted their experience Good/Superb</label>
      </div>
    )
  }

  renderRatingBreakDown = () => {
    const breakdown = this.props.breakdown;
    if (!breakdown) {
      return null;
    }
    const sum = Object.values(breakdown).reduce((res, cur) => res + cur, 0);
    return (
      <div className='ratingBreakdown'>
        {['superb', 'good', 'poor'].map(type =>
          <div key={type} className={`ratingItem ${type}`}>
            <div className='ratingInfo'>
              <span>{type} ({breakdown[type] || 0})</span>
            </div>
            <div className='valueContainer'>
              <div className='ratingValue' style={{width: `${breakdown[type] / sum * 100}%`}}/>
            </div>
          </div>
        )}
      </div>
    )
  }

  render = () => {
    return (
      <div className='overallRatingView'>
        <div className='content'>
          {this.renderTotalRating()}
          {this.renderRatingBreakDown()}
        </div>
      </div>
    )
  }

}
